import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Pickup } from '../../../models/pickup';
import { Observable } from 'rxjs';

export class PickupData implements DataSource<Pickup> {

    constructor(private source$: Observable<Pickup[]>) {
    }

    connect(collectionViewer: CollectionViewer): Observable<Pickup[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }
}
